export const TIME_RANGE_SLIDER_DEFAULT_MIN = 0
export const TIME_RANGE_SLIDER_DEFAULT_MAX = 24
